import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsCategoryOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-[0_1px_3px_rgba(0,0,0,0.5)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-2xl font-heading font-bold text-primary-500">97</span>
          <span className="text-xl font-heading font-semibold text-foreground-50">影视</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors hover:text-primary-400 whitespace-nowrap ${
              location.pathname === '/' ? 'text-primary-500' : 'text-foreground-200'
            }`}
          >
            首页
          </Link>

          <div
            className="relative"
            onMouseEnter={() => setIsCategoryOpen(true)}
            onMouseLeave={() => setIsCategoryOpen(false)}
          >
            <button
              className={`text-sm font-medium transition-colors hover:text-primary-400 whitespace-nowrap flex items-center gap-1 ${
                location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-200'
              }`}
            >
              分类浏览
              <i className={`ri-arrow-down-s-line text-xs transition-transform ${isCategoryOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {isCategoryOpen && (
              <div className="absolute top-full left-0 mt-2 bg-background-100 border border-background-300/60 rounded-lg py-2 min-w-[180px] shadow-lg">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="block px-4 py-2 text-sm text-foreground-200 hover:text-primary-400 hover:bg-background-200 transition-colors whitespace-nowrap"
                  >
                    <i className={`${cat.icon} mr-2`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
            )}
          </div>

          <Link
            to="/about"
            className={`text-sm font-medium transition-colors hover:text-primary-400 whitespace-nowrap ${
              location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-200'
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="搜索电影..."
              className="w-[200px] bg-background-200 border border-background-300/60 rounded-full px-4 py-1.5 text-sm text-foreground-100 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50 transition-colors"
            />
            <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
          </div>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-100"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-300/30 px-4 py-4">
          <div className="flex flex-col gap-3">
            <Link to="/" className="text-sm text-foreground-200 hover:text-primary-400 py-2">首页</Link>
            <div className="text-sm text-foreground-200 py-2 font-medium">分类浏览</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-sm text-foreground-300 hover:text-primary-400 pl-4 py-1"
              >
                <i className={`${cat.icon} mr-2`}></i>
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="text-sm text-foreground-200 hover:text-primary-400 py-2">关于我们</Link>
            <div className="relative mt-2">
              <input
                type="text"
                placeholder="搜索电影..."
                className="w-full bg-background-200 border border-background-300/60 rounded-full px-4 py-2 text-sm text-foreground-100 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50"
              />
              <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}